import {Model} from "@vuex-orm/core";

export default class PackageRegion extends Model {
    static entity = 'packageRegion'

    static primaryKey = ['package_id', 'region_id']

    static fields () {
        return {
            package_id: this.number(null).nullable(),
            region_id: this.number(null).nullable()
        }
    }
}
